import isLocal from '../common/isLocal.js'

const packageToFolder = {
  tpaIntegration: 'Santa-Integration-Protractor',
  wixCodeIntegration: 'js-wixcode-integration',
  viewerIntegration: 'viewer-integration',
  platformIntegrationEditor: 'js-platform-integration',
  tpaIntegrationEditor: 'Santa-Editor-Integration-Protractor'}

function getLocalBasePath(baseArtifact) {
  const protocol = (/^https?:/.exec(baseArtifact) || [''])[0]
  return `${protocol}//localhost:4578`
}

export default function getIntegrationPath(packageName, baseArtifact) {
  const integrationBasePath = isLocal(baseArtifact) ? getLocalBasePath(baseArtifact) :
    `https://s3.amazonaws.com/integration-tests-statics/${packageToFolder[packageName]}/SNAPSHOT/runners`

  return `${integrationBasePath}/${packageName}/src/main`
}


// WEBPACK FOOTER //
// ./node_modules/santa-main-r/src/lib/common/getIntegrationPath.js